export { default } from './es/icons/PptTwoTone';